// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8445 ? "bc98253f" : chunkId) + "." + {"3969":"e26cef5135fd7965","5678":"8a3fbcef7db64a15","8445":"f6efc8d1e0028bf6","8848":"cfbd8b445f497cae"}[chunkId] + ".js";
};